import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { INTRO_TEXT_CONVERTER_TOKEN, IntroTextConverter } from './intro-text.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        introTextFeature: {
          module: () => import('./intro-text.module').then((m) => m.IntroTextModule),
          cmsComponents: ['intro_text'],
        },
      }
    }),
    {
      provide: INTRO_TEXT_CONVERTER_TOKEN,
      useExisting: IntroTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        intro_text: INTRO_TEXT_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class IntroTextFeatureModule {}
